import React from 'react'
import Header from '../components/Header/Header'
import MinusReportPage from '../components/allClasses/MinusReportPage'

function MinusReport() {
  return (
    <div>
        <Header/>
        <MinusReportPage/>
    </div>
  )
}

export default MinusReport